import { genrateIcon } from '../../../constant/icons';
import { VIEW } from '../../../constant/commonConst';

const LedgerReportPopup = (props:any) => {
  const { column, rowData } = props;
  return (
    <div>
        <div onClick={()=>{
            column.callBack({ data: rowData, status: VIEW });
        }}>
            {genrateIcon.icon}
        </div>
    </div>
  )
}

export default LedgerReportPopup
